// extracted by mini-css-extract-plugin
export var divider = "_rc-0";
export var systemMessage = "_rc-1";
export var systemMessageWrapper = "_rc-2";